import React, { cache, useEffect, useState } from "react";
import DateRange from "../../components/DateRange/DateRange";
import { useLocation, useNavigate } from "react-router-dom";
import { useGlobalContext } from "../../Services/PaginationGlobal";
import { Table } from "../../components/Table/Table";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
import Topbar from "../../components/Topbar/Topbar";
import { eye_primary, Search_icon } from "../../assets/img";
import moment from "moment";

export default function UserFailedTransaction({ activeTab,selectedFilter,setSelectedFilter }) {
  const { paginationData, setpaginationData } = useGlobalContext();
  const location = useLocation();
  const navigate = useNavigate();

  const path = location.pathname?.replace("/", "");
  const [count, setCount] = useState(0);

  const [page, setPage] = useState(
    paginationData?.[path]?.[activeTab]?.page ?? 1,
  );
  const [transactions, setTransactions] = useState([]);
  const [pagination, setPagination] = useState({});

  const [activeGateway, setActiveGateway] = useState("Razor Pay");
  const gateways_pay = ["Razor Pay", "Cash Free"];
  const handleChangeFilter = (name, val) => {
    if (name !== "from" && val) setPage(1);
    setSelectedFilter((prev) => ({ ...prev, [name]: val }));
  };

  const transactionFailed = async ({ id, action }) => {
    navigate("/failedtransactionview", {
      state: { mode: !action ? "add" : "view", data: {}, id: id },
    });
  };

  console.log(
    "selectedFilter",
    selectedFilter,
    "activeGateway0",
    activeGateway,
    "activeTab0",
    activeTab,
  );

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "User ID",
        accessor: "user_code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "User Name",
        accessor: "user_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Mobile Number",
        accessor: "phone_number",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Attempts",
        accessor: "no_of_transactions",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Latest failed Date",
        accessor: "latest_failed_date",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Amount",
        accessor: "latest_failed_amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Action",
        Cell: ({ row }) => {
          const is_read = row.original.is_read;
          console.log("AKDKSKDK", row?.original);

          return (
            <button
              onClick={() =>
                transactionFailed({
                  id: row.original.alert_id,
                  action: is_read,
                })
              }
              className="cust-btn"
            >
              <img src={eye_primary} alt="eye" />
            </button>
          );
        },
      },
    ],
    [page],
  );

  const getList = async (pageNumber = 1) => {
    const { from, to, search } = selectedFilter;
    const payload = new FormData();

    if (!from || !to) return;
    payload.append("from_date", from);
    payload.append("to_date", to);
    payload.append(
      "notes_filter",
      activeTab === "Responded" ? "with_notes" : "without_notes",
    );
    payload.append("search", search);
    
    console.log("payload ", payload);
    // payload.append(
    //   "gateway",
    //   activeGateway == "Razor Pay" ? "razorpay" : "cashfree",
    // );
    // if (selectedFilter?.status) {
    //   payload.append("status", selectedFilter?.status?.value);
    // }
    const res = await post(
      `${URLS.USER_FAILED_TRANSACTION}?page=${pageNumber}`,
      payload,
    );
    console.log("mmc transactions list", res);
    if (res?.status === "success") {
      setCount(res?.count);
      setPagination({
        current_page: pageNumber,
        last_page: res?.total_pages,
      });
      setTransactions(res?.data);
    }
  };

  useEffect(() => {
     getList(page);

    setpaginationData((prev) => ({
      ...prev,
      [path]: {
        ...prev?.[path],
        [activeTab]: { page: page, search: selectedFilter.search },
      },
    }));
  }, [
    page,
    activeGateway,
    selectedFilter.from,
    selectedFilter?.to,
    selectedFilter.search,
    activeTab
  ]);
  console.log("selectedFilter", selectedFilter);
  return (
    <div>
      <div
        style={{
          padding: "14px 16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 8,
          flexWrap: "wrap",
        }}
      >
        <div className="search-input">
          <input
            onChange={(e) => {
              handleChangeFilter("search", e.target.value);
            }}
            type="text"
            placeholder="Search"
            style={{ border: "none", width: "150px" }}
            value={selectedFilter.search}
          />
          <img alt="" src={Search_icon} className="search" />
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <DateRange
            currentDay={true}
            setFromDate={(date) => {
              handleChangeFilter("from", date);
            }}
            setToDate={(date) => {
              handleChangeFilter("to", date);
            }}
          />
        </div>
      </div>

      <div
        style={{
          padding: "0 16px 14px",
          fontSize: 13,
          color: "#374151",
          fontSize: "18px",
          fontWeight: "600",
        }}
      >
        Total count : <strong>{count}</strong>
      </div>

      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={transactions}
        show={true}
      />
    </div>
  );
}
